import { Dispatch } from "react"
import { CoreGracePeriod } from "../models/CoreModels"
import { EmptyRequestState, RequestState } from "../models/RequestState"
import InstanceClient from "../services/InstanceClient"
import StatusCode from "../util/StatusCode"
import { Action, Reducer } from "redux"


enum ModuleGracePeriodType {
    GET_GRACE_PERIODS = 'GET_GRACE_PERIODS',
    CREATE_GRACE_PERIOD = 'CREATE_GRACE_PERIOD',
    UPDATE_GRACE_PERIOD = 'UPDATE_GRACE_PERIOD',
    DELETE_GRACE_PERIOD = 'DELETE_GRACE_PERIOD',
}

export interface ModuleGracePeriodState {
    moduleGracePeriods: RequestState<CoreGracePeriod[]>
    createModuleGracePeriod: EmptyRequestState
    updateModuleGracePeriod: EmptyRequestState
    deleteModuleGracePeriod: EmptyRequestState
}

interface ModuleGracePeriod_Get extends Action<ModuleGracePeriodType> {
    type: ModuleGracePeriodType.GET_GRACE_PERIODS
    moduleGracePeriods: RequestState<CoreGracePeriod[]>
};

interface ModuleGracePeriod_Create extends Action<ModuleGracePeriodType> {
    type: ModuleGracePeriodType.CREATE_GRACE_PERIOD
    createModuleGracePeriod: EmptyRequestState
};

interface ModuleGracePeriod_Update extends Action<ModuleGracePeriodType> {
    type: ModuleGracePeriodType.UPDATE_GRACE_PERIOD
    updateModuleGracePeriod: EmptyRequestState
};

interface ModuleGracePeriod_Delete extends Action<ModuleGracePeriodType> {
    type: ModuleGracePeriodType.DELETE_GRACE_PERIOD
    deleteModuleGracePeriod: EmptyRequestState
};

type ModuleGracePeriodAction =
    ModuleGracePeriod_Get |
    ModuleGracePeriod_Create |
    ModuleGracePeriod_Update |
    ModuleGracePeriod_Delete;

export const GetModuleGracePeriods = (moduleId: string) => (dispatch: Dispatch<ModuleGracePeriod_Get>) => {
    dispatch({
        type: ModuleGracePeriodType.GET_GRACE_PERIODS,
        moduleGracePeriods: { code: StatusCode.PENDING }
    });
    return InstanceClient.get<CoreGracePeriod[]>(`/api/core/module/${moduleId}/moduleGracePeriods`)
        .then(res => {
            dispatch({
                type: ModuleGracePeriodType.GET_GRACE_PERIODS,
                moduleGracePeriods: { code: StatusCode.COMPLETE, data: res.data }
            });
        })
        .catch(err => {
            dispatch({
                type: ModuleGracePeriodType.GET_GRACE_PERIODS,
                moduleGracePeriods: { code: StatusCode.ERROR, error: err }
            });
        });
};

export const CreateModuleGracePeriod = (moduleId: string, gracePeriod: Partial<CoreGracePeriod>) => (dispatch: Dispatch<ModuleGracePeriod_Create>) => {
    dispatch({
        type: ModuleGracePeriodType.CREATE_GRACE_PERIOD,
        createModuleGracePeriod: { code: StatusCode.PENDING }
    });
    return InstanceClient.post(`/api/core/module/${moduleId}/createGracePeriod`, gracePeriod)
        .then(res => {
            dispatch({
                type: ModuleGracePeriodType.CREATE_GRACE_PERIOD,
                createModuleGracePeriod: { code: StatusCode.COMPLETE }
            });
            return StatusCode.COMPLETE;
        })
        .catch(error => {
            dispatch({
                type: ModuleGracePeriodType.CREATE_GRACE_PERIOD,
                createModuleGracePeriod: { code: StatusCode.ERROR, error }
            });
            return StatusCode.ERROR;
        });
};

export const UpdateModuleGracePeriod = (moduleId: string, gracePeriod: Partial<CoreGracePeriod>) => (dispatch: Dispatch<ModuleGracePeriod_Update>) => {
    dispatch({
        type: ModuleGracePeriodType.UPDATE_GRACE_PERIOD,
        updateModuleGracePeriod: { code: StatusCode.PENDING }
    });
    return InstanceClient.put(`/api/core/module/${moduleId}/editGracePeriod`, gracePeriod)
        .then(response => {
            dispatch({
                type: ModuleGracePeriodType.UPDATE_GRACE_PERIOD,
                updateModuleGracePeriod: { code: StatusCode.COMPLETE }
            });
            return StatusCode.COMPLETE;
        })
        .catch(error => {
            dispatch({
                type: ModuleGracePeriodType.UPDATE_GRACE_PERIOD,
                updateModuleGracePeriod: { code: StatusCode.ERROR, error }
            });
            return StatusCode.ERROR;
        });
};

export const DeleteModuleGracePeriod = (moduleId: string, id: string) => (dispatch: Dispatch<ModuleGracePeriod_Delete>) => {
    dispatch({
        type: ModuleGracePeriodType.DELETE_GRACE_PERIOD,
        deleteModuleGracePeriod: { code: StatusCode.PENDING }
    });
    return InstanceClient.delete(`/api/core/module/${moduleId}/deleteGracePeriod/${id}`)
        .then(response => {
            dispatch({
                type: ModuleGracePeriodType.DELETE_GRACE_PERIOD,
                deleteModuleGracePeriod: { code: StatusCode.COMPLETE }
            });
            return StatusCode.COMPLETE;
        })
        .catch(error => {
            dispatch({
                type: ModuleGracePeriodType.DELETE_GRACE_PERIOD,
                deleteModuleGracePeriod: { code: StatusCode.ERROR, error }
            });
            return StatusCode.ERROR;
        });
};

const initialState: ModuleGracePeriodState = {
    moduleGracePeriods: { code: StatusCode.NONE },
    createModuleGracePeriod: { code: StatusCode.NONE },
    updateModuleGracePeriod: { code: StatusCode.NONE },
    deleteModuleGracePeriod: { code: StatusCode.NONE },
}

export const reducer: Reducer<ModuleGracePeriodState, ModuleGracePeriodAction> = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case ModuleGracePeriodType.GET_GRACE_PERIODS:
            return {
                ...state,
                moduleGracePeriods: action.moduleGracePeriods
            };
        case ModuleGracePeriodType.CREATE_GRACE_PERIOD:
            return {
                ...state,
                createModuleGracePeriod: action.createModuleGracePeriod
            };
        case ModuleGracePeriodType.UPDATE_GRACE_PERIOD:
            return {
                ...state,
                updateModuleGracePeriod: action.updateModuleGracePeriod
            };
        case ModuleGracePeriodType.DELETE_GRACE_PERIOD:
            return {
                ...state,
                deleteModuleGracePeriod: action.deleteModuleGracePeriod
            };
        default:
            return state;
    }
}